import { Button, ListCard } from '@dfh-corp-sites/ui'
import { ChevronRight } from '@dfh-corp-sites/ui/icons'
import { Maybe } from 'graphql/jsutils/Maybe'
import React from 'react'

import { ParentProduct, SanityImage } from '../../../graphql/search'
import { handleProductTagCategoryPriority } from '../../../lib/products/tags'
import useSanityImage from '../../../lib/sanity/hooks/useSanityImage'
import Link from '../../global/Link'

import productImagePlaceholder from '../../../img/product-image-placeholder.png'

export interface ParentProductListCardProps {
  className?: string
  product: Pick<ParentProduct, 'name' | 'urlKey'> & {
    mainImage?: Maybe<Pick<SanityImage, 'json'>>
    tagCategories?: string[]
  }
}

const ParentProductListCard: React.FC<ParentProductListCardProps> = ({ product }) => {
  const sanityImageUrl = useSanityImage(
    { sourceJson: product.mainImage?.json || undefined },
    {
      dpr: 2,
      fit: 'max',
      width: 100,
    },
  )
  const imageUrl = sanityImageUrl || productImagePlaceholder

  return (
    <ListCard
      title={product.name}
      heading="Product"
      tag={handleProductTagCategoryPriority(product.tagCategories || [])}
      image={{
        alt: product.name || '',
        src: imageUrl,
      }}
      cta={
        <Button asChild variant="text">
          <Link className="flex items-center gap-3.5" to={`products/${product.urlKey}`}>
            See product details
            <ChevronRight aria-hidden className="size-3 md:size-4" />
          </Link>
        </Button>
      }
    />
  )
}

export default ParentProductListCard
